<template>
  <div>
    <v-container>
      <v-row
          align="center"
          justify="end"
      >
        <v-col
            cols="12"
        >
          <div style="text-align: center;">
            <div class="text-h6">
              綁定成功，請關閉此頁面返回 Linerp
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>

export default {
  async created() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    const parts = state.split(',');

    if (code) {
      console.log('start line relation');
      const res = await this.$api.collection.storeApi.relationLineNotifyAccessToken(parts[0], code);
      console.log(res);
      this.isBoundSuccessfully = true;
      window.location.href = window.location.origin + `/provider-store/${parts[1]}/line-notify-store/relation`;
    }
  },
  data() {
    return {
    };
  }
};
</script>
